import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faWandMagicSparkles } from "@fortawesome/pro-solid-svg-icons";
import { faBlockBrick } from "@fortawesome/pro-regular-svg-icons";

import Card from "@/components/card/index.tsx";
import ProjectEditButton from "@/components/buttons/project-edit-button";

import FlowMode from "@/models/enums/flow-mode.ts";

interface DetectionCardActionProps {
    flowMode: FlowMode;
    storeysFileDataHasScale: boolean;
    hasMetresDepuisPDF: boolean;
    isLoading: boolean;
    onClick: () => void;
}

const DetectionCardAction: React.FC<DetectionCardActionProps> = ({
    flowMode,
    storeysFileDataHasScale,
    hasMetresDepuisPDF,
    isLoading,
    onClick,
}) => 
    (
        <>
            {(flowMode === FlowMode._2D3D || flowMode === FlowMode._2D3DAdvanced) &&
                <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
                    <ProjectEditButton
                        variant='simple'
                        size='sm'
                        onClick={onClick}
                        disabled={isLoading || !storeysFileDataHasScale}
                    >
                        <div className='flex flex-row gap-x-2 items-center'>
                            <div className='flex flex-row gap-x-1 items-baseline'>
                                <FontAwesomeIcon icon={faBlockBrick} />
                                <FontAwesomeIcon icon={faWandMagicSparkles} />

                                {hasMetresDepuisPDF &&
                                    <FontAwesomeIcon icon={faCheck} className='text-green-500' />
                                }
                            </div>
                            <span>Détection automatique</span>
                        </div>
                    </ProjectEditButton>

                    <div>
                        <span>Obtenez automatiquement</span>
                        <ul className='list-disc list-inside pl-2 text-sm'>
                            <li>Mur</li>
                            <li>Porte</li>
                            <li>Fenêtre</li>
                        </ul>
                    </div>
                </Card>
            }
        </>
    );

export default DetectionCardAction;